import React from 'react';
import {withNamespaces} from 'react-i18next';

function Select({t, id, error, info, label, value, disabled, onChange, placeholder, className, options}) {
  className = `form-control ${error ? 'is-invalid' : ''} ${className ? className : ''}`;

  const labelEl = label !== false
    ? (
      <label htmlFor={id}>
        {t('form.' + id + '.label')}
      </label>
    )
    : null;
  
  const infoEl = info
      ? (
        <small class="form-text text-muted">
          {info} 
        </small>
      )
      : null;

  return (
    <div className="mb-4">
      {labelEl}
      
      <select
        name={id}
        id={id}
        className={className}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
      >
        {options.map(({label, value}, i) => (
          <option key={i} value={value}>
            {label}
          </option>
        ))}
      </select>

      {infoEl}
      
      <div className="invalid-feedback">
        {error}
      </div>
    </div>
  );
}

export default withNamespaces()(Select);